








// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartEvolutionContainer from '@/components/charts/ChartEvolutionContainer.vue';
// Import plugins ----------------------------------------------------------------------------------
import i18n from '@/plugins/i18n';
// Import utils - ----------------------------------------------------------------------------------
import { useChart, EThemeColor } from '@/utils/charts.utils';
import { EUnitKey } from '@/utils/parameter-units.utils';
// Import types ------------------------------------------------------------------------------------
import type { TDataStandard } from '@/components/patient/PatientEvolution.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartEvolutionHeelStrike',
  components: {
    ChartEvolutionContainer
  },
  props: {
    manifest: {
      type: Array,
      required: true
    },
    heelStrike: {
      type: Object
    },
    norms: {
      type: Object
    }
  },
  setup(properties) {
    const {
      evolutionChartStructure,
      getSideData,
      getSideDataVariations,
      getSerieItemStructure,
      getNormsStructure
    } = useChart();

    const title = 'commons.standards.heel-strike';

    const heelStrike: TDataStandard = computed(() => getSideData(properties.heelStrike));

    const dataVariations = computed(() =>
      getSideDataVariations({ left: heelStrike.value.left.values, right: heelStrike.value.right.values })
    );

    const series = computed(() => {
      let data = [
        // Left
        getSerieItemStructure(
          'heel_strike_left',
          `${i18n.t('commons.standards.heel-strike')} (${(i18n.t('commons.standards.left') as string).slice(
            0,
            1
          )})`,
          heelStrike.value.left.values,
          EThemeColor.Chart1
        ),
        getSerieItemStructure(
          'heel_strike_left',
          undefined,
          heelStrike.value.left.ranges,
          EThemeColor.Chart1,
          true
        ),
        // Right
        getSerieItemStructure(
          'heel_strike_right',
          `${i18n.t('commons.standards.heel-strike')} (${(i18n.t('commons.standards.right') as string).slice(
            0,
            1
          )})`,
          heelStrike.value.right.values,
          EThemeColor.Chart2
        ),
        getSerieItemStructure(
          'heel_strike_right',
          undefined,
          heelStrike.value.right.ranges,
          EThemeColor.Chart2,
          true
        )
      ];
      // Have norms
      if (properties.norms)
        data.push(
          getNormsStructure('heel_strike_norms', properties.norms as { min: number[]; max: number[] })
        );

      return data;
    });

    const chartOptions = computed(() => {
      return {
        ...evolutionChartStructure(title, properties.manifest, EUnitKey.Degree, 1),
        series: series.value
      };
    });

    return {
      title,
      dataVariations,
      chartOptions
    };
  }
});
